import React from 'react'

import cctv from "../images/CCTV Camera cp plus.jpg";
import GPSMap from "../images/GPS security.jpg";
import inetercom from "../images/Intercom photo.jpg";
import Comutercare from "../images/computer dell.jpg";


import sensorsystem from "../images/Sensor.jpg";
import audiovideo from "../images/Audio photo.jpg";
import Electricalservice from "../images/Electrical  Services.jpg"
import allaccessories from "../images/All Accessories.jpg";






function Services() {
    return (
        <div>


            <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='cctv_camera'>
                                            <div className="card shadow">


                                                <img src={cctv} className="card-img-top" alt="cctv" />


                                                <div className="card-body">
                                                    <h5 style={{ color: "#0C6624" }} className="card-title mb-1"><b>CCTV Camera</b></h5>
                                                    <p className="card-text mb-2"><small>High-resolution CCTV Camera designed for 24/7 surveillance.<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                    </svg></small></p>

<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                                </div>
                                            </div>
                                            </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">

                                    <a href='computer-care'>
                                    <div className='cardmotation'>
                                        <div className="card shadow">

                                            <img src={Comutercare} className="card-img-top" alt="Comutercare" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }} className="card-title mb-1" ><b>Laptop & PC</b>                                </h5>
                                                <p className="card-text mb-2"><small>Fast and reliable repair for PC, laptop, and printer.<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg></small></p>

<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>
                                            </div>
                                        </div>

                                    </div>
                                    </a>
                                    

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <a href='intercom-system'>
                                    <div className='#'>
                                        <div className="card shadow">

                                            <img src={inetercom} className="card-img-top" alt="inetercom" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }}  className="card-title mb-1"><b>Inetercom</b> </h5>
                                                <p className="card-text mb-2"><small>Intercom System – Clear and secure communication. <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg></small></p>
<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                            </div>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='gps_system'>
                                        <div className="card shadow">

                                            <img src={GPSMap} className="card-img-top" alt="GPSMap" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }} className="card-title mb-1"><b>GPS System</b> </h5>
                                                <p className="card-text mb-2"><small>GPS System with live tracking and accurate navigation.<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg> </small></p>
<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                            </div>
                                        </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
   <div className="album py-0">
                <div className="container">
                    <div className="row">

                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <div className='cardmotation'>
                                        <a href='sensor_system'>
                                            <div className="card shadow">


                                                <img src={sensorsystem} className="card-img-top" alt="sensorsystem" />


                                                <div className="card-body">
                                                    <h5 style={{ color: "#0C6624" }} className="card-title mb-1"><b>Sensor System</b></h5>
                                                    <p className="card-text mb-2"><small>Smart sensor system for fast alerts and reliable safety. <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                    </svg></small></p>

<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                                </div>
                                            </div>
                                            </a>
                                    </div>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <div className='cardmotation'>
                                        <a href='audio-video'>
                                        <div className="card shadow">

                                            <img src={audiovideo} className="card-img-top" alt="audiovideo" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }} className="card-title mb-1"><b>Audio Video</b>  </h5>
                                                <p className="card-text mb-2"><small>PQuality audio-video setup for smooth communication.<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg> </small></p>
<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                            </div>
                                        </div>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                                <div className="col-md-6 me-2 mt-3">
                                    <a href='Electricservices'>
                                    <div className='cardmotation'>
                                        <div className="card shadow">

                                            <img src={Electricalservice} className="card-img-top" alt="Electricalservice" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }} className="card-title mb-1"><b>Electrical Service</b></h5>
                                                <p className="card-text mb-2"><small>Reliable electrical installation and repair services.<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg></small></p>
<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                            </div>
                                        </div>
                                    </div>
                                    </a>
                                </div>
                                <div className="col-md-6  mt-3">
                                    <a href='AllAccessories'>
                                    <div className='cardmotation'>
                                        <div className="card shadow">

                                            <img src={allaccessories} className="card-img-top" alt="allaccessories" />

                                            <div className="card-body">
                                                <h5 style={{ color: "#0C6624" }} className="card-title mb-1" ><b>All Accessories</b>                                  </h5>
                                                <p className="card-text mb-2"><small>All essential accessories with quality and reliable support. <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                                                </svg></small></p>
<button className='learnmore'>Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
</svg></button>

                                            </div>
                                        </div>

                                    </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <br />

            <br />
        </div>
    )
}

export default Services